import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

const emptyForm = {
  page_path: "/",
  title: "",
  description: "",
  keywords: "",
  og_title: "",
  og_description: "",
  og_image: "",
  canonical_url: "",
  robots: "index,follow",
  schema_json: "",
  status: "active",
};

export default function AdminSeoPageForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;
    api(`/api/admin/seo-pages/${id}`)
      .then((data) => setForm({ ...emptyForm, ...data }))
      .catch((err) => setError(err.message));
  }, [id]);

  function update(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function submit(e) {
    e.preventDefault();
    setError("");
    try {
      await api(id ? `/api/admin/seo-pages/${id}` : "/api/admin/seo-pages", {
        method: id ? "PUT" : "POST",
        body: JSON.stringify(form),
      });
      navigate("/adxm/seo");
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <AdminLayout title={id ? "Edit SEO Page" : "Add SEO Page"} subtitle="Improve Google ranking, social sharing and page metadata.">
      <form onSubmit={submit} className="mx-auto max-w-5xl rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
        <div className="grid gap-4 md:grid-cols-2">
          <label className="block font-bold">Page Path<input name="page_path" value={form.page_path} onChange={update} required className="mt-2 w-full rounded-xl border p-3" placeholder="/departments" /></label>
          <label className="block font-bold">Status<select name="status" value={form.status} onChange={update} className="mt-2 w-full rounded-xl border p-3"><option value="active">Active</option><option value="inactive">Inactive</option></select></label>
        </div>
        <label className="mt-4 block font-bold">SEO Title<input name="title" value={form.title} onChange={update} required maxLength="255" className="mt-2 w-full rounded-xl border p-3" /></label>
        <label className="mt-4 block font-bold">Meta Description<textarea name="description" value={form.description || ""} onChange={update} rows="3" className="mt-2 w-full rounded-xl border p-3" /></label>
        <label className="mt-4 block font-bold">Keywords<textarea name="keywords" value={form.keywords || ""} onChange={update} rows="2" className="mt-2 w-full rounded-xl border p-3" placeholder="admissions, departments, research" /></label>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          <label className="block font-bold">Open Graph Title<input name="og_title" value={form.og_title || ""} onChange={update} className="mt-2 w-full rounded-xl border p-3" /></label>
          <label className="block font-bold">Open Graph Image URL<input name="og_image" value={form.og_image || ""} onChange={update} className="mt-2 w-full rounded-xl border p-3" /></label>
        </div>
        <label className="mt-4 block font-bold">Open Graph Description<textarea name="og_description" value={form.og_description || ""} onChange={update} rows="3" className="mt-2 w-full rounded-xl border p-3" /></label>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          <label className="block font-bold">Canonical URL<input name="canonical_url" value={form.canonical_url || ""} onChange={update} className="mt-2 w-full rounded-xl border p-3" /></label>
          <label className="block font-bold">Robots<select name="robots" value={form.robots} onChange={update} className="mt-2 w-full rounded-xl border p-3"><option>index,follow</option><option>noindex,follow</option><option>index,nofollow</option><option>noindex,nofollow</option></select></label>
        </div>
        <label className="mt-4 block font-bold">Schema JSON-LD<textarea name="schema_json" value={form.schema_json || ""} onChange={update} rows="7" className="mt-2 w-full rounded-xl border p-3 font-mono text-xs" placeholder='{"@context":"https://schema.org","@type":"CollegeOrUniversity"}' /></label>
        <button className="mt-6 rounded-xl bg-emerald-700 px-6 py-3 font-bold text-white">Save SEO Page</button>
      </form>
    </AdminLayout>
  );
}
